<div class="edit-page-root-container sale-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{getTitle()}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>

                }
            </div>
        </div>

        <!-- <mat-tab-group style="background: transparent;">
            <mat-tab label="Sale items" style="text-align: left;"> -->
        <div class="page-details">

            <form class="edit-form" [formGroup]="editForm">
                <mat-tab-group style="background: #fff;">
                    <mat-tab label="Sale item">
                        <div class="detail-section">
                            <div class="content-container">
                                <!-- <div class="input-group">
                                    <div class="input-box-right">
                                        <mat-form-field class="name">
                                            <mat-label>Stock Item Name</mat-label>
                                            <input #input
                                                   type="text"
                                                   matInput
                                                   [formControl]="myControl"
                                                   [matAutocomplete]="auto"
                                                   (blur)="onInputBlur()">
                                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                                              <mat-option *ngFor="let stock of filteredOptions; trackBy: trackById" [value]="stock.name">
                                                {{ stock.name }}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>                                     
                                    </div>
                                    <div class="input-box-left">
                                        <mat-form-field class="code">
                                            <mat-label>Stock item code</mat-label>
                                            <input matInput maxlength="20" [value]="selectedStock?.code || ''" readonly>
                                        </mat-form-field>                                        
                                    </div>

                                </div> -->
                                <!-- <div>
                                    <mat-form-field style="width:50%;">
                                        <mat-label>Item type</mat-label>
                                            <mat-select formControlName="item_type" [(value)]="selectedValue">

                                            <mat-option value="1">Regular item</mat-option>
                                            <mat-option value="2">Customizable item</mat-option>
                                            <mat-option value="3">Combo item</mat-option>
                                          </mat-select>
                                          
                                    </mat-form-field>


                                </div> -->
                                <div class="input-group">
                                    <div class="input-box-left">
                                        <mat-form-field class="name">
                                            <mat-label>Code</mat-label>
                                            <input matInput maxlength="50" formControlName="code" appCodeInput
                                                [readonly]="isEditMode">
                                            <mat-error *ngIf="editForm.controls['code'].hasError('required')">code
                                                should be
                                                entered</mat-error>
                                            <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum
                                                length is
                                                10.</mat-error>
                                        </mat-form-field>
                                    </div>


                                    <div class="input-box-right">
                                        <mat-form-field class="name">
                                            <mat-label>Name</mat-label>
                                            <input matInput formControlName="name">
                                        </mat-form-field>
                                    </div>

                                </div>
                                <div class="input-group">
                                    <div class="input-box-left">
                                        <mat-form-field class="name">
                                            <mat-label>Short Name</mat-label>
                                            <input matInput formControlName="short_name">
                                        </mat-form-field>
                                    </div>
                                    <div class="input-box-right">
                                        <mat-form-field class="name">
                                            <mat-label>Alternative Name</mat-label>
                                            <input matInput formControlName="alternative_name">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-box-left">
                                        <mat-form-field class="name">
                                            <mat-label>Name To Print</mat-label>
                                            <input matInput formControlName="name_to_print">
                                        </mat-form-field>
                                    </div>
                                    <div class="input-box-right">
                                        <mat-form-field class="name">
                                            <mat-label>Alternative Name To Print</mat-label>
                                            <input matInput formControlName="alternative_name_to_print">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-box-right">
                                        <mat-form-field class="description">
                                            <mat-label>Description</mat-label>
                                            <textarea matInput formControlName="description"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-box-left">
                                        <mat-form-field class="name">
                                            <mat-label>Barcode</mat-label>
                                            <input matInput formControlName="barcode">
                                            <mat-error *ngIf="editForm.get('barcode')?.hasError('duplicateBarcode')">
                                                This barcode is already assigned to another active item.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="input-box-right">
                                        <mat-form-field class="block-input" style="width: 100%;">
                                            <mat-label>Item Class</mat-label>
                                            <input type="text" aria-label="Stock Item Name" matInput
                                                formControlName="sub_class_id" [matAutocomplete]="auto">
                                            <button matSuffix mat-icon-button aria-label="Clear"
                                                (click)="clearItemClass()" *ngIf="editForm.get('sub_class_id')?.value">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                                [displayWith]="displayItemClass">
                                                @for (itemClass of filteredItemClasses | async; track itemClass.id)
                                                {
                                                <mat-option [value]="itemClass.id">{{itemClass.name}}</mat-option>
                                                }
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-box-left">
                                        <mat-form-field class="block-input" style="width: 100%;">
                                            <mat-label>Item Type</mat-label>
                                            <input type="text" aria-label="Item Type" matInput
                                                formControlName="item_type" [matAutocomplete]="itemTypeAuto"
                                                [readonly]="isEditMode" (optionSelected)="onItemTypeSelected($event)">
                                            <button matSuffix mat-icon-button aria-label="Clear"
                                                (click)="clearItemType()"
                                                *ngIf="editForm.get('item_type')?.value && !isEditMode">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            <mat-autocomplete #itemTypeAuto="matAutocomplete" autoActiveFirstOption
                                                [displayWith]="displayItemType">
                                                @for (itemType of itemTypes; track itemType.id)
                                                {
                                                <mat-option [value]="itemType.id">{{itemType.name}}</mat-option>
                                                }
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>

                                    <div class="input-box-right">
                                        <div class="grouping-section" style="display: flex; align-items: center;">
                                            <mat-form-field style="width:100%; margin-right: 10px;">
                                                <mat-label>Group Item</mat-label>
                                                <input type="text" matInput placeholder="Select grouping"
                                                    [formControl]="groupItemControl" [matAutocomplete]="autoGroupItem">
                                                <button matSuffix mat-icon-button aria-label="Clear"
                                                    (click)="clearGroupItem()"
                                                    *ngIf="editForm.get('group_item_id')?.value">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                                <mat-autocomplete #autoGroupItem="matAutocomplete"
                                                    [displayWith]="displayGroupItem" autoActiveFirstOption
                                                    (optionSelected)="onGroupItemAutocompleteSelected($event)">
                                                    <mat-option *ngFor="let groupItem of filteredGroupItems | async"
                                                        [value]="groupItem">
                                                        {{groupItem.name}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>

                                            <button mat-raised-button color="primary" class="group-item-button"
                                                *ngIf="!editForm.get('group_item_id')?.value"
                                                (click)="onGroupItemAddClick()">Add</button>
                                            <button mat-raised-button color="accent" class="group-item-button"
                                                *ngIf="editForm.get('group_item_id')?.value"
                                                (click)="onGroupItemEditClick()">Edit</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="content-container">
                                    <div style="display: flex;gap: 10px;">
                                        <div class="sub-title">
                                            Display Colors
                                        </div>
                                        <div style="margin-top: -10px;">
                                            <mat-checkbox (change)="toggleColorInput($event.checked)"
                                                formControlName="use_multi_color">Use
                                                Multicolor?</mat-checkbox>
                                        </div>
                                    </div>
                                    <div class="color-container">
                                        <mat-form-field class="color-chooser fg-color">
                                            <mat-label>Foreground Color</mat-label>
                                            <input matInput type="color" formControlName="fg_color">
                                        </mat-form-field>
                                        <mat-form-field class="color-chooser bg-color">
                                            <mat-label>Background Color @if(isMultiColorChecked)
                                                {<span>1</span>}</mat-label>
                                            <input matInput type="color" formControlName="bg_color">
                                        </mat-form-field>
                                        @if(isMultiColorChecked) {
                                        <mat-form-field class="color-chooser bg-color">
                                            <mat-label>Background Color 2</mat-label>
                                            <input matInput type="color" formControlName="bg_color2">
                                        </mat-form-field>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <!-- <div class="content-container">
        <div style="display: flex; gap: 15px; align-items: center; margin-bottom: 15px;">
            <div class="sub-title" style="margin: 0;">Taxation, Pricing, Cost and UOM</div>
            <mat-checkbox formControlName="is_open">Open Price</mat-checkbox>
        </div>

        <div class="input-group">
            <div class="input-box-left">
                <mat-form-field class="inclusive-tax block-input" style="width: 100%;">
                    <mat-label>Tax Mode</mat-label>
                    <input matInput value="Inclusive of Tax" readonly>
                </mat-form-field>
            </div>
            
            <div class="input-box-right">
                <mat-form-field style="width: 100%;">
                    <mat-label>Tax</mat-label>
                    <input type="text" matInput placeholder="Select tax" formControlName="tax_id"
                        [formControl]="taxControl" [matAutocomplete]="autoTax">
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="clearTax()" *ngIf="editForm.get('tax_id')?.value">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete #autoTax="matAutocomplete" [displayWith]="displayTax" autoActiveFirstOption (optionSelected)="onTaxSelected($event)">
                        <mat-option *ngFor="let taxItem of filteredTax | async" [value]="taxItem">{{taxItem.name}}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div class="input-group">
            <div class="input-box-left" style="display: flex; gap: 10px;">
                <mat-form-field class="cost" style="flex: 1;">
                    <mat-label>Cost</mat-label>
                    <input matInput formControlName="item_cost" type="number">
                </mat-form-field>
                
                <mat-form-field class="fixed-price" style="flex: 1;">
                    <mat-label>Fixed Price</mat-label>
                    <input matInput formControlName="fixed_price" type="number">
                </mat-form-field>
            </div>
            
            <div class="input-box-right"></div>
        </div>
    </div> -->
                                <div class="">
                                    <div class="content-container">
                                        <div style="display: flex; gap: 15px; align-items: center; margin-bottom: 5px;">
                                            <div class="sub-title" style="margin: 0;">Taxation, Pricing, Cost and UOM
                                            </div>
                                            @if (!isComboItem) {
                                                <mat-checkbox formControlName="is_open">Open Price</mat-checkbox>
                                            }
                                        </div>

                                        <div class="input-group" style="align-items: baseline;">
                                            <div class="input-box-left">
                                                <mat-form-field class="inclusive-tax block-input" style="width: 100%;">
                                                    <mat-label>Tax Mode</mat-label>
                                                    <input matInput value="Inclusive of Tax" readonly>
                                                </mat-form-field>
                                            </div>

                                            <div class="input-box-right">
                                                <mat-form-field style="width: 100%;">
                                                    <mat-label>Tax</mat-label>
                                                    <input type="text" matInput placeholder="Select tax"
                                                        formControlName="tax_id" [matAutocomplete]="autoTax">
                                                    <button matSuffix mat-icon-button aria-label="Clear"
                                                        (click)="clearTax()" *ngIf="editForm.get('tax_id')?.value">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                    <mat-autocomplete #autoTax="matAutocomplete"
                                                        [displayWith]="displayTax" autoActiveFirstOption>
                                                        <mat-option *ngFor="let taxItem of filteredTax | async"
                                                            [value]="taxItem.id">{{taxItem.name}}</mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="input-group" style="align-items: baseline;">
                                            <div class="input-box-left" style="display: flex; gap: 10px;">
                                                <mat-form-field class="cost" style="width: 115px;">
                                                    <mat-label>Cost</mat-label>
                                                    <input matInput formControlName="item_cost" type="number">
                                                </mat-form-field>

                                                <mat-form-field class="fixed-price" style="width: 115px;">
                                                    <mat-label>Fixed Price</mat-label>
                                                    <input matInput formControlName="fixed_price" type="number"
                                                        [readonly]="(this.userData?.user_type == 'SHOP') || isComboItem">
                                                </mat-form-field>

                                                <button mat-stroked-button
                                                    *ngIf="this.userData?.user_type == 'HQ' && isEditMode"
                                                    style="margin-left: 10px; height: 50px; margin-top: 4px;"
                                                    (click)="openShopPricesModal()">
                                                    Shop Prices
                                                </button>
                                            </div>
                                            @if (this.userData?.user_type == 'SHOP') {
                                            <div class="input-box-right"
                                                style="display: flex; gap: 10px; align-items: flex-start;">
                                                <mat-form-field class="shop-price" style="width: 125px;">
                                                    <mat-label>Shop Price</mat-label>
                                                    <input matInput formControlName="shop_price" type="number"
                                                        [readonly]="isShopPriceDefined"
                                                        (input)="onShopPriceInput($event)"
                                                        (keydown)="preventNegative($event)">
                                                </mat-form-field>

                                                <button mat-flat-button *ngIf="!isShopPriceDefined"
                                                    style="background-color: #007bff; color: white; height: 50px; padding: 0 30px; margin-top: 4px; font-weight: bold; border-radius: 4px;"
                                                    (click)="onUpdateShopPrice()">
                                                    UPDATE
                                                </button>

                                                <button mat-flat-button *ngIf="isShopPriceDefined"
                                                    style="background-color: #9b0000; color: white; height: 50px; padding: 0 30px; margin-top: 4px; font-weight: bold; border-radius: 4px;"
                                                    (click)="onResetShopPrice()">
                                                    RESET
                                                </button>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="content-container">
                                    <div class="sub-title">Sales Channels
                                    </div>
                                    <mat-checkbox formControlName="is_direct_sale_allowed"> In-Store</mat-checkbox>
                                    <mat-checkbox formControlName="is_oo_direct_sale_allowed"> Online</mat-checkbox>
                                </div>
                            </div>
                            <div class="">
                                <div style="display: flex;gap:20px; margin-top: 20px;">
                                    <!-- <div class="sub-title">Kitchen
                                    </div> -->
                                    <mat-form-field style="width:35%;">
                                        <mat-label>UOM</mat-label>
                                        <input type="text" matInput placeholder="Select UOM" formControlName="uom_id"
                                            [matAutocomplete]="autoUom">
                                        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearUom()"
                                            *ngIf="editForm.get('uom_id')?.value">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-autocomplete #autoUom="matAutocomplete" [displayWith]="displayUom"
                                            autoActiveFirstOption>
                                            <mat-option *ngFor="let uom of filteredUom | async" [value]="uom.id">
                                                {{uom.name}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%;">
                                        <mat-label>Kitchen</mat-label>
                                        <input type="text" matInput placeholder="Select kitchen"
                                            [formControl]="kitchenControl" [matAutocomplete]="autoKitchen">
                                        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearKitchen()"
                                            *ngIf="editForm.get('kitchen_id')?.value">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-autocomplete #autoKitchen="matAutocomplete" [displayWith]="displayKitchen"
                                            autoActiveFirstOption (optionSelected)="onKitchenSelected($event)">
                                            <mat-option *ngFor="let kitchen of filteredKitchen | async"
                                                [value]="kitchen">
                                                {{kitchen.name}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <div style="margin-top: 10px;">
                                        <mat-checkbox formControlName="print_on_demand">On Demand</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="" *ngIf="showHotItemsConfiguration">
                                <div class="content-container">
                                    <div class="sub-title">This item is also available under these special keys
                                    </div>
                                    <!-- Example: Hot Items Table -->
                                    <table mat-table [dataSource]="hotItems" class="mat-elevation-z1"
                                        style="width: 100%;margin-top: 5px;">
                                        <!-- Header Row -->
                                        <ng-container matColumnDef="label">
                                            <th mat-header-cell *matHeaderCellDef></th>
                                            <td mat-cell *matCellDef="let element">{{element.label}}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="hot1">
                                            <th mat-header-cell *matHeaderCellDef>HOT ITEM 1</th>
                                            <td mat-cell *matCellDef="let element"
                                                [ngClass]="element.type === 'menu' ? 'gray-bg' : ''">
                                                <ng-container [ngSwitch]="element.type">
                                                    <mat-checkbox *ngSwitchCase="'enabled'" class="hot-item-checkbox"
                                                        formControlName="is_hot_item_1"></mat-checkbox>
                                                    <input *ngSwitchCase="'order'" matInput type="text"
                                                        formControlName="hot_item_1_display_order"
                                                        class="hot-item-input">
                                                </ng-container>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="hot2">
                                            <th mat-header-cell *matHeaderCellDef>HOT ITEM 2</th>
                                            <td mat-cell *matCellDef="let element"
                                                [ngClass]="element.type === 'menu' ? 'gray-bg' : ''">
                                                <ng-container [ngSwitch]="element.type">
                                                    <mat-checkbox *ngSwitchCase="'enabled'" class="hot-item-checkbox"
                                                        formControlName="is_hot_item_2"></mat-checkbox>
                                                    <input *ngSwitchCase="'order'" matInput type="text"
                                                        formControlName="hot_item_2_display_order"
                                                        class="hot-item-input">
                                                </ng-container>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="hot3">
                                            <th mat-header-cell *matHeaderCellDef>HOT ITEM 3</th>
                                            <td mat-cell *matCellDef="let element"
                                                [ngClass]="element.type === 'menu' ? 'gray-bg' : ''">
                                                <ng-container [ngSwitch]="element.type">
                                                    <mat-checkbox *ngSwitchCase="'enabled'" class="hot-item-checkbox"
                                                        formControlName="is_hot_item_3"></mat-checkbox>
                                                    <input *ngSwitchCase="'order'" matInput type="text"
                                                        formControlName="hot_item_3_display_order"
                                                        class="hot-item-input">
                                                </ng-container>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="dt">
                                            <th mat-header-cell *matHeaderCellDef>DRIVE THROUGH</th>
                                            <td mat-cell *matCellDef="let element">
                                                <ng-container [ngSwitch]="element.type">
                                                    <mat-checkbox *ngSwitchCase="'enabled'" class="hot-item-checkbox"
                                                        formControlName="is_dt_item"></mat-checkbox>
                                                    <input *ngSwitchCase="'order'" matInput type="text"
                                                        formControlName="dt_display_order" class="hot-item-input">
                                                    <input *ngSwitchCase="'menu'" matInput type="text"
                                                        formControlName="dt_menu_number" class="hot-item-input">
                                                </ng-container>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <div style="margin-top: 12px;">
                                        @if
                                        (editForm.get('hot_item_1_display_order')?.hasError('pattern')||editForm.get('hot_item_2_display_order')?.hasError('pattern')||editForm.get('hot_item_3_display_order')?.hasError('pattern')||editForm.get('dt_display_order')?.hasError('pattern'))
                                        {
                                        <mat-error>
                                            Only numbers are allowed
                                        </mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="" style="margin-top:30px;margin-bottom:30px;">
                                <div class="content-container">
                                    <div class="sub-title">Others
                                    </div>
                                    <div style="display: flex;gap:25px;">
                                        <mat-checkbox formControlName="is_valid"> Valid</mat-checkbox>
                                        <mat-checkbox formControlName="is_require_weighing"> Require
                                            Weighing</mat-checkbox>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="isCustomizableItem" label="Customization">
                        <div style="padding: 20px;">
                            <div class="customization-header">
                                <div class="copy-field">
                                    <mat-form-field>
                                        <mat-label>Copy from</mat-label>
                                        <input type="text" matInput placeholder="Select item to copy from"
                                            [formControl]="copyItemControl" [matAutocomplete]="autoCopyItem">
                                        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearCopyItem()"
                                            *ngIf="copyItemControl.value">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-autocomplete #autoCopyItem="matAutocomplete"
                                            [displayWith]="displayCopyItem"
                                            (optionSelected)="onCopyItemSelected($event)">
                                            <mat-option *ngFor="let item of filteredCopyItems | async" [value]="item">
                                                {{item.name}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>

                                <div class="copy-button-container">
                                    <button mat-raised-button color="primary" class="copy-button"
                                        (click)="onCopyButtonClicked()">
                                        COPY DATA FROM THIS ITEM
                                    </button>
                                </div>
                            </div>

                            <div id="customizationScrollContainer"
                                style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd;">
                                <table mat-table [dataSource]="customizationOptions"
                                    class="mat-elevation-z1 sticky-header-table" style="width: 100%;">
                                    <ng-container matColumnDef="optionName">
                                        <th mat-header-cell *matHeaderCellDef class="table-heading sticky-header"
                                            style="width: 35%; position: sticky; top: 0; z-index: 100; background: white;">
                                            Option Name</th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                            <mat-form-field style="margin-top: 10px;margin-bottom:-10px;"
                                                class="example-full-width">
                                                <input type="text" matInput placeholder="Select"
                                                    aria-label="Option Name" [formControl]="optionNameControl[i]"
                                                    [matAutocomplete]="autoOptionName">
                                                <button matSuffix mat-icon-button aria-label="Clear"
                                                    (click)="clearOptionName(i)" *ngIf="optionNameControl[i]?.value">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                                <mat-autocomplete #autoOptionName="matAutocomplete"
                                                    [displayWith]="displayOptionName"
                                                    (optionSelected)="onOptionNameSelected($event, i)">
                                                    <mat-option *ngFor="let item of filteredSaleItems[i] | async"
                                                        [value]="item.id">
                                                        {{item.name}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="displayName">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: inherit; text-align: left; width: 15%; position: sticky; top: 0; z-index: 100;">
                                            Display Name</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span style="display: block; padding: 10px 0; font-size: 14px;">
                                                {{element.displayName || ''}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="defaultOptions">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: inherit; width: 15%; position: sticky; top: 0; z-index: 100;">
                                            Default Option
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span style="display: block; padding: 10px 0; font-size: 14px;">
                                                {{element.defaultOptions || ''}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="displayOrder">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: inherit; position: sticky; top: 0; z-index: 100;">
                                            Display Order
                                        </th>
                                        <td mat-cell *matCellDef="let element" style="text-align: right;">
                                            <mat-form-field style="width: 70px;margin-top: 10px;margin-bottom:-10px;">
                                                <input matInput type="number" [(ngModel)]="element.display_order"
                                                    [ngModelOptions]="{standalone: true}" min="0" pattern="^[0-9]*$"
                                                    #custDisplayOrder="ngModel" style="width: 50px;text-align: right;">
                                                <mat-error *ngIf="custDisplayOrder.invalid">Invalid</mat-error>
                                            </mat-form-field>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="valid">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: inherit; position: sticky; top: 0; z-index: 100;">
                                            Valid</th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox [(ngModel)]="element.is_valid"
                                                [ngModelOptions]="{standalone: true}"></mat-checkbox>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="actions">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; position: sticky; top: 0; z-index: 100;">
                                            <button mat-raised-button color="primary" (click)="addCustomizationRow()">
                                                Add
                                            </button>
                                        </th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                            <button mat-icon-button color="warn" (click)="removeCustomizationRow(i)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row
                                        *matHeaderRowDef="['optionName', 'displayName', 'defaultOptions', 'displayOrder', 'valid', 'actions']">
                                    </tr>
                                    <tr mat-row
                                        *matRowDef="let row; columns: ['optionName', 'displayName', 'defaultOptions', 'displayOrder', 'valid', 'actions'];">
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="isComboItem" label="Combo">
                        <div style="padding: 20px;">
                            <div class="customization-header" style="background-color: white; 
                                padding: 10px; 
                                border-radius: 4px; 
                                margin-bottom: 16px;">
                                <div style="flex:1;"></div>
                                <div style="font-weight: bold;flex: 1;text-align: end;">
                                    TOTAL COMBO PRICE : {{ totalComboPrice | currency:'USD':'symbol':'1.2-2' }}
                                </div>
                            </div>
                            <div id="comboScrollContainer"
                                style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd;">
                                <table mat-table [dataSource]="comboOptions"
                                    class="mat-elevation-z1 sticky-header-table" style="width: 100%;">
                                    <ng-container matColumnDef="optionName">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; width: 20%; position: sticky; top: 0; z-index: 100;">
                                            OPTION NAME</th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                            <mat-form-field style="width: 100%;margin-top: 10px;">
                                                <input type="text" matInput placeholder="Select option"
                                                    [value]="getComboOptionDisplayName(element.combo_option_id)"
                                                    [matAutocomplete]="autoComboOption"
                                                    (input)="onComboOptionInput($event, i)">
                                                <button matSuffix mat-icon-button aria-label="Clear"
                                                    (click)="clearComboOption(i)" *ngIf="element.combo_option_id">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                                <mat-autocomplete #autoComboOption="matAutocomplete"
                                                    autoActiveFirstOption
                                                    (optionSelected)="onComboOptionAutocompleteSelected($event, i)">
                                                    <mat-option *ngFor="let opt of filteredComboOptions" [value]="opt">
                                                        {{opt.name}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="displayName">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            DISPLAY NAME</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span style="display: block; padding: 10px; font-size: 14px;">
                                                {{element.combo_option_name || ''}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="defaultOptions">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            DEFAULT OPTIONS</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span style="display: block; padding: 10px; font-size: 14px;">
                                                {{element.option_value_name || ''}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="price">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            PRICE</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span
                                                style="display: block; padding: 10px; font-size: 14px; text-align: right;">
                                                {{(element.price || 0) | currency:'USD':'symbol':'1.2-2'}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="isPerc">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            IS PERC.</th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox [(ngModel)]="element.is_percentage"
                                                [ngModelOptions]="{standalone: true}" disabled></mat-checkbox>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="var">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            VAR</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span
                                                style="display: block; padding: 10px; font-size: 14px; text-align: right;">
                                                {{(element.price_variance || 0) | currency:'USD':'symbol':'1.2-2'}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="discPrice">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            DISC.PRICE</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span
                                                style="display: block; padding: 10px; font-size: 14px; text-align: right;">
                                                {{(element.discount_price || 0) | currency:'USD':'symbol':'1.2-2'}}
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="displayOrder">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; font-weight: bold; position: sticky; top: 0; z-index: 100;">
                                            DISP.ORD</th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-form-field style="width: 70px;margin-top: 10px;margin-bottom:-10px;">
                                                <input matInput type="number" [(ngModel)]="element.display_order"
                                                    [ngModelOptions]="{standalone: true}" min="0" pattern="^[0-9]*$"
                                                    #comboDisplayOrder="ngModel" style="width: 50px;">
                                                <mat-error *ngIf="comboDisplayOrder.invalid">Invalid</mat-error>
                                            </mat-form-field>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="actions">
                                        <th mat-header-cell *matHeaderCellDef class="sticky-header"
                                            style="background: white; position: sticky; top: 0; z-index: 100;">
                                            <button mat-raised-button color="primary" (click)="addComboRow()">
                                                Add
                                            </button>
                                        </th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                            <button mat-icon-button color="warn" (click)="removeComboRow(i)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row
                                        *matHeaderRowDef="['optionName', 'displayName', 'defaultOptions', 'price', 'isPerc', 'var', 'discPrice', 'displayOrder', 'actions']">
                                    </tr>
                                    <tr mat-row
                                        *matRowDef="let row; columns: ['optionName', 'displayName', 'defaultOptions', 'price', 'isPerc', 'var', 'discPrice', 'displayOrder', 'actions'];">
                                    </tr>
                                </table>
                            </div>

                        </div>
                    </mat-tab>
                </mat-tab-group>
            </form>

        </div>
        <!-- </mat-tab> 
    @if(selectedValue === '2'){
<mat-tab label="Customization"></mat-tab>
    }@else if(selectedValue === '3'){
        <mat-tab label="Combo Items"></mat-tab>


    }


</mat-tab-group> -->

    </div>
</div>